import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';

import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';

@customElement('sp-loading-more')
export class SpLoadingMore extends LitElement {
    static styles = [
        //language=css
        css`
            :host {
                width: 100%;
                height: 4rem;
                display: grid;
                place-content: center;
            }
            
            sl-spinner {
                font-size: 2rem;
            }
        `
    ];

    render() {
        return html`<sl-spinner></sl-spinner>`;
    }
}
